import { render, staticRenderFns } from "./DetalhesAviso.vue?vue&type=template&id=8a6cc8f0"
import script from "./DetalhesAviso.vue?vue&type=script&lang=ts"
export * from "./DetalhesAviso.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesAviso.vue?vue&type=style&index=0&id=8a6cc8f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports